import { createFileRoute, notFound } from "@tanstack/react-router";

import { BASE_URL, OG_VERSION } from "@/common/links";
import { getPageContent } from "@/features/docs/content";
import { DocPage } from "@/landing/docs/DocPage";

export const Route = createFileRoute("/_steward/docs/$slug")({
  loader: ({ params }) => {
    const page = getPageContent(params.slug);
    if (!page) throw notFound();
    return { ...page, slug: params.slug };
  },
  head: ({ loaderData }) => ({
    meta: [
      { title: `${loaderData?.title}: Wonda Docs` },
      ...(loaderData?.description
        ? [
            { name: "description", content: loaderData.description },
            { property: "og:description", content: loaderData.description },
            { name: "twitter:description", content: loaderData.description },
          ]
        : []),
      {
        property: "og:title",
        content: `${loaderData?.title}: Wonda Docs`,
      },
      {
        property: "og:url",
        content: `${BASE_URL}/docs/${loaderData?.slug}`,
      },
      {
        name: "twitter:title",
        content: `${loaderData?.title}: Wonda Docs`,
      },
      {
        property: "og:image",
        content: `${BASE_URL}/og/docs/${loaderData?.slug}.png?v=${OG_VERSION}`,
      },
      {
        name: "twitter:image",
        content: `${BASE_URL}/og/docs/${loaderData?.slug}.png?v=${OG_VERSION}`,
      },
    ],
    links: [
      {
        rel: "canonical",
        href: `${BASE_URL}/docs/${loaderData?.slug}`,
      },
    ],
    scripts: loaderData
      ? [
          {
            type: "application/ld+json",
            children: JSON.stringify({
              "@context": "https://schema.org",
              "@type": "Article",
              headline: loaderData.title,
              ...(loaderData.description && {
                description: loaderData.description,
              }),
              url: `${BASE_URL}/docs/${loaderData.slug}`,
              publisher: {
                "@type": "Organization",
                name: "Wonda",
                url: BASE_URL,
              },
            }),
          },
          {
            type: "application/ld+json",
            children: JSON.stringify({
              "@context": "https://schema.org",
              "@type": "BreadcrumbList",
              itemListElement: [
                {
                  "@type": "ListItem",
                  position: 1,
                  name: "Home",
                  item: BASE_URL,
                },
                {
                  "@type": "ListItem",
                  position: 2,
                  name: "Docs",
                  item: `${BASE_URL}/docs`,
                },
                {
                  "@type": "ListItem",
                  position: 3,
                  name: loaderData.title,
                  item: `${BASE_URL}/docs/${loaderData.slug}`,
                },
              ],
            }),
          },
        ]
      : [],
  }),
  component: DocSlugPage,
});

function DocSlugPage() {
  const page = Route.useLoaderData();

  return (
    <DocPage
      title={page.title}
      description={page.description}
      content={page.content}
    />
  );
}
